import axios from "axios";
import { processAxiosError } from "../processAxiosError";
import { eCommentReviewStatus } from "./interface";
import { ICommentsReturn } from "./patchAllCommentStatus";

export interface PatchHierarchyCommentThreadDetails {
  activeContext: "Hierarchy";
  hierarchyId: string;
  commentId: string;
  newStatus: eCommentReviewStatus;
}
export interface PatchTlfItemCommentThreadDetails {
  activeContext: "TlfItem";
  id: string;
  azsolId: string;
  version: number;
  commentId: string;
  newStatus: eCommentReviewStatus;
}

export type PatchCommentThreadDetails =
  | PatchHierarchyCommentThreadDetails
  | PatchTlfItemCommentThreadDetails;

/**
 * Update a comment thread's status (all comments in the thread).
 *
 * @param backEndUrl - Base backend URL
 * @param details - Details identifying the thread and new status
 * @param controller - AbortController to cancel the request
 * @returns Updated comments wrapped in ICommentsReturn
 */
export const patchCommentThreadStatus = async (
  backEndUrl: string,
  details: PatchCommentThreadDetails,
  controller: AbortController,
): Promise<ICommentsReturn> => {
  const url =
    details.activeContext === "Hierarchy"
      ? `${backEndUrl}Hierarchy/${details.hierarchyId}/CommentThreadStatus/${details.commentId}`
      : `${backEndUrl}TlfItems/${details.id}/CommentThreadStatus/${details.commentId}`;

  try {
    const ret = await axios.patch(
      url,
      {
        status: details.newStatus,
      },
      {
        signal: controller.signal,
      },
    );
    return {
      success: true,
      data: ret.data,
    };
  } catch (error) {
    return processAxiosError("Update comment failed", error);
  }
};
